<template>
  <Card class="sec__batt-card" @click="$emit('click')" v-ripple>
    <div class="text-xs-center py-3">{{ item.name }}</div>
    <v-divider class="custom-divider" />
    <v-layout row wrap mt-3 align-center>
      <v-flex xs12 md6 d-flex justify-center>
        <v-progress-circular :rotate="360" :size="120" :width="10" :value="(item.subsys_cnt || 0) * 10" color="#E9952A">
          <div class="circle-text-large">
            {{ item.subsys_cnt != null ? item.subsys_cnt : 'N/A' }}
          </div>
          <div class="circle-text-small">
            SUB BATTERY
          </div>
        </v-progress-circular>
      </v-flex>
      <v-flex hidden-sm-and-down md1 d-flex justify-center>
        <v-divider vertical class="custom-vertical-divider"></v-divider>
      </v-flex>
      <v-flex xs12 md5>
        <div class="text-xs-left caption">Subsys Count</div>
        <div class="na-value text-xs-left">{{ item.subsys_cnt != null ? item.subsys_cnt : 'N/A' }}</div>
      </v-flex>

      <v-flex xs12>
        <v-layout row wrap mt-4 px-4>
          <v-flex xs12 sm6 class="mb-3">
            <div class="text-xs-left caption">Max discharge Current Allowed</div>
            <div class="text-xs-left" :class="item.max_dischrg_cur_alwd == null ? 'na-value' : 'value'">
              {{ item.max_dischrg_cur_alwd == null ? 'N/A' : item.max_dischrg_cur_alwd }} A
            </div>
          </v-flex>
          <v-flex xs12 sm6 class="mb-3">
            <div class="text-xs-left caption">Max charge Current Allowed</div>
            <div class="text-xs-left" :class="item.max_chrg_cur_alwd == null ? 'na-value' : 'value'">
              {{ item.max_chrg_cur_alwd == null ? 'N/A' : item.max_chrg_cur_alwd }} A
            </div>
          </v-flex>
          <v-flex xs12 sm6>
            <div class="text-xs-left caption">CELL TEMPERATURE - Min</div>
            <div class="text-xs-left" :class="item.min_cell_temp == null ? 'na-value' : 'value'">
              {{ item.min_cell_temp != null ? item.min_cell_temp : 'N/A' }} °C
            </div>
          </v-flex>
          <v-flex xs12 sm6>
            <div class="text-xs-left caption">CELL TEMPERATURE - Max</div>
            <div class="text-xs-left" :class="item.max_cell_temp == null ? 'na-value' : 'value'">
              {{ item.max_cell_temp != null ? item.max_cell_temp : 'N/A' }} °C
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </Card>
</template>

<script>
export default {
  name: "MainBatteryItem",
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.sec__batt-card {
  border: 1px solid #334079 !important;
  border-radius: 8px;
  padding-bottom: 25px;
  padding-top: 10px;
  transition: all 0.3s ease;
}

.sec__batt-card:hover {
  cursor: pointer;
  background-color: var(--v-bg-base) !important;
  border-color: #668cf6 !important;
  box-shadow: 0 0 20px rgba(102, 140, 246, 0.3);
  transform: translateY(-4px);
}

.sec__batt-card:active {
  transform: translateY(-1px);
  box-shadow: 0 0 10px rgba(102, 140, 246, 0.2);
}

.circle-text-large {
  font-weight: 700;
  font-size: 30px;
  line-height: 1;
}

.theme--light .circle-text-large {
  color: var(--v-black-lighten1);
}

.theme--dark .circle-text-large {
  color: var(--v-white-lighten3);
}

.circle-text-small {
  font-weight: 500;
  font-size: 12px;
}

.theme--light .circle-text-small {
  color: var(--v-secondaryText-base);
}

.theme--dark .circle-text-small {
  color: var(--v-grey-base);
}

.custom-vertical-divider {
  height: 60px;
  border: 3px solid #334079 !important;
}

.caption {
  font-size: 0.8rem;
  margin-bottom: 2px;
}

.theme--dark .caption {
  color: var(--v-grey-base);
}

.theme--light .caption {
  color: var(--v-secondaryText-darken3);
}

.value {
  font-size: 1.2rem;
  font-weight: 700;
  color: #668cf6;
}

.na-value {
  font-size: 1.2rem;
  font-weight: 700;
  color: #ff5252;
}

.custom-divider {
  border-color: #334079 !important;
}
</style>
